// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles-module__tableContainer__src-labstep-web-components-Permission-Table-_pfMC1"};